/** Match a navigation section without matching unrelated path prefixes. */
export function isMarketingRouteActive(
  pathname: string,
  section: string
): boolean {
  return pathname === section || pathname.startsWith(`${section}/`);
}

// Pipeline trial (Abu, Oct 29): Product and Resources are hidden so the nav
// is Pricing, MCP, Sign in and the CTA. Set to true to bring them back.
export const SHOW_PRODUCT_AND_RESOURCES = false;
